import { render, staticRenderFns } from "./task_new.vue?vue&type=template&id=18142f0c&scoped=true&"
import script from "./task_new.vue?vue&type=script&lang=js&"
export * from "./task_new.vue?vue&type=script&lang=js&"
import style0 from "./task_new.vue?vue&type=style&index=0&id=18142f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18142f0c",
  null
  
)

export default component.exports